import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from "@angular/core";
import { BaseModal } from "@modals/base-modal";
import { IServicePoint } from "@models/v2/service-point.model";
import { BreadcrumbService } from "@services/breadcrumb.service";
import { ServicePointService } from "@services/service-point.service";
import { UserService } from "@services/user.service";

@Component({
	selector: 'service-point-info-modal',
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './service-point-info-modal.html',
	styleUrls: ['./service-point-info-modal.scss']
})
export class ServicePointInfoModalComponent extends BaseModal implements OnInit {

	private userService: UserService = inject(UserService);
	private servicePointService: ServicePointService = inject(ServicePointService);

	public _servicePoint = signal<IServicePoint[]>([]);

	constructor(breadcrumbService: BreadcrumbService) {
		super(breadcrumbService);
	}

	async ngOnInit() {
		const user = await this.userService.getUserData();
		
		const servicePoints = await this.servicePointService.getServicePointsByCountryCode(user.CountryCode);
		this._servicePoint.set(servicePoints);
	}

}